const DJMiniCart = (() => {
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[character]);
  const drawer = () => document.querySelector('[data-mini-cart]');
  const body = () => document.querySelector('[data-mini-cart-body]');
  const footer = () => document.querySelector('[data-mini-cart-footer]');

  function render(cart) {
    document.querySelectorAll('[data-cart-count], [data-mini-cart-count]').forEach(element => element.textContent = cart.item_count);
    document.querySelectorAll('[data-mini-cart-total]').forEach(element => element.textContent = money(cart.total_price));
    if (!cart.items.length) {
      body().innerHTML = '<div class="dj-mini-cart-empty"><p>Your bag is currently empty.</p><a class="dj-text-link" href="/collections/all">Discover the collection →</a></div>';
      footer().hidden = true;
      return;
    }
    body().innerHTML = cart.items.map(item => `
      <article class="dj-mini-cart-item">
        <a class="dj-mini-cart-image" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=320" alt="${escapeHtml(item.product_title)}">` : ''}</a>
        <div class="dj-mini-cart-info">
          <a href="${escapeHtml(item.url)}"><h3>${escapeHtml(item.product_title)}</h3></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <strong>${money(item.final_line_price)}</strong>
          <div class="dj-mini-cart-actions">
            <div class="dj-mini-cart-quantity" aria-label="Quantity">
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-cart-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="dj-mini-cart-remove" data-cart-change="${escapeHtml(item.key)}" data-cart-quantity="0">Remove</button>
          </div>
        </div>
      </article>`).join('');
    footer().hidden = false;
  }

  async function getCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async function refresh() { const cart = await getCart(); render(cart); return cart; }
  async function open() {
    drawer()?.classList.add('is-open');
    document.querySelector('[data-mini-cart-overlay]')?.classList.add('is-open');
    drawer()?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dj-cart-open');
    try { await refresh(); } catch { body().innerHTML = '<p>We couldn’t load your bag. Please try again.</p>'; }
  }
  function close() {
    drawer()?.classList.remove('is-open');
    document.querySelector('[data-mini-cart-overlay]')?.classList.remove('is-open');
    drawer()?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dj-cart-open');
  }
  async function add(form, button, resetLabel = 'Add to Bag') {
    const originalLabel = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add item');
      if (button) button.textContent = 'Added';
      await open();
    } catch {
      if (button) button.textContent = 'Try again';
    }
    window.setTimeout(() => { if (button) { button.disabled = false; button.textContent = originalLabel || resetLabel; } }, 1400);
  }
  async function change(key, quantity) {
    body()?.classList.add('is-updating');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!response.ok) throw new Error('Unable to update cart');
      render(await response.json());
    } finally { body()?.classList.remove('is-updating'); }
  }
  return { add, open, close, change };
})();

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }
  async onSubmit(event) {
    event.preventDefault();
    await DJMiniCart.add(this.form, event.submitter || this.form.querySelector('button'), 'Quick add');
  }
}
customElements.define('product-form', ProductForm);
document.addEventListener('submit', event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add') || form.closest('product-form')) return;
  event.preventDefault();
  DJMiniCart.add(form, event.submitter || form.querySelector('button'));
});
document.addEventListener('click', event => {
  const cartToggle = event.target.closest('[data-mini-cart-toggle]');
  if (cartToggle) { event.preventDefault(); DJMiniCart.open(); return; }
  if (event.target.closest('[data-mini-cart-close], [data-mini-cart-overlay]')) { DJMiniCart.close(); return; }
  const cartChange = event.target.closest('[data-cart-change]');
  if (cartChange) { DJMiniCart.change(cartChange.dataset.cartChange, Number(cartChange.dataset.cartQuantity)); return; }
  const carouselDot = event.target.closest('.dj-carousel-dot');
  if (carouselDot) {
    const wrapper = carouselDot.closest('.dj-mobile-carousel-wrap');
    const carousel = wrapper?.querySelector('[data-carousel]');
    const item = carousel?.children[Number(carouselDot.dataset.carouselIndex)];
    item?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    return;
  }

  const carouselArrow = event.target.closest('.dj-carousel-arrow');
  if (carouselArrow) {
    const carousel = carouselArrow.closest('.dj-mobile-carousel-wrap')?.querySelector('[data-carousel]');
    if (carousel) {
      const direction = carouselArrow.dataset.carouselDirection === 'previous' ? -1 : 1;
      carousel.scrollBy({ left: direction * carousel.clientWidth * .82, behavior: 'smooth' });
    }
    return;
  }

  const productThumb = event.target.closest('.dj-product-thumb');
  if (productThumb) {
    const mainImage = document.getElementById('ProductMainImage');
    if (mainImage) {
      mainImage.src = productThumb.dataset.productImage;
      mainImage.removeAttribute('srcset');
      document.querySelectorAll('.dj-product-thumb').forEach(thumb => thumb.classList.remove('is-active'));
      productThumb.classList.add('is-active');
    }
    return;
  }

  const toggle = event.target.closest('.dj-menu-toggle');
  if (toggle) {
    const menu = document.getElementById('DJMenu');
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    toggle.classList.toggle('is-open', !open);
    menu?.classList.toggle('is-open', !open);
    return;
  }

  const submenuToggle = event.target.closest('.dj-submenu-toggle');
  if (!submenuToggle) return;
  const item = submenuToggle.closest('.dj-nav-item--dropdown');
  const open = submenuToggle.getAttribute('aria-expanded') === 'true';
  submenuToggle.setAttribute('aria-expanded', String(!open));
  item?.classList.toggle('is-open', !open);
});

document.querySelectorAll('[data-carousel]').forEach(carousel => {
  carousel.addEventListener('scroll', () => {
    const items = Array.from(carousel.children);
    if (!items.length) return;
    const activeIndex = items.reduce((best, item, index) => Math.abs(item.offsetLeft - carousel.scrollLeft) < Math.abs(items[best].offsetLeft - carousel.scrollLeft) ? index : best, 0);
    const dots = carousel.closest('.dj-mobile-carousel-wrap')?.querySelectorAll('.dj-carousel-dot');
    dots?.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
  }, { passive: true });
});
